import { mergeMap } from 'rxjs/operators';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { PricingRuleAction } from '../pricingRule.action';
import { PricingRuleTranslator } from '../pricingRule.translator';

type IDependencies = IClientApiDependencySegment;

export const loadPricingRuleEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(PricingRuleAction.loadList.started),
  mergeMap((params) => {
    return dependencies.api.getPricingRules().pipe(
      mergeMap((response) => {
        const result = (response.rules ?? []).map(PricingRuleTranslator.fromApi);

        return [
          PricingRuleAction.loadList.done({ params, result }),
        ];
      }),
      catchApiError((error) => {
        return [
          PricingRuleAction.loadList.failed({ params, error }),
          createApiErrorNotification(error),
        ];
      }),
    );
  }),
);
